/**
 * normalizeOrgWorkStatus.ts
 * V62: 조직 근로현황 BE → FE 필드 정규화 유틸리티
 * V63: OrgWorkStatusPage에서 공용 유틸로 이동
 *
 * getOrgWorkStatusMonthly 응답 전용
 */

/**
 * FE 표준 타입: 조직 근로현황 직원 월간 통계
 */
export interface EmployeeMonthlyStats {
  userId: string;
  employeeId: string;
  name: string;
  orgUnitName: string;
  positionName: string;
  jobTitle: string;
  workDays: number;
  scheduledHours: number;
  actualHours: number;
  lateCount: number;
  overtimeHours: number;
  compOffAccrued: number;
  compOffUsed: number;
  absenceCount: number;
  annualUsed: number;
  publicDutyUsed: number;
}

/**
 * V62: BE→FE 필드명 정규화 함수 (단일 지점에서 매핑)
 *
 * BE 필드명 → FE 필드명 매핑:
 * - employeeId → userId (BE는 employeeId를 PK로 사용)
 * - nameKo → name
 * - jobTitleName → jobTitle
 * - workingDays → workDays
 * - regularHours → scheduledHours
 * - compOffAccruedDays (V60.x) / compOffAccruedHours (legacy) → compOffAccrued
 * - compOffUsedDays (V60.x) / compOffUsedHours (legacy) → compOffUsed
 * - annualLeaveUsedDays → annualUsed
 * - publicDutyUsedDays → publicDutyUsed
 */
export function normalizeEmployeeStats(raw: any): EmployeeMonthlyStats {
  return {
    // ID
    userId: raw.employeeId ?? raw.userId ?? '',
    employeeId: raw.employeeId ?? '',

    // 기본 정보
    name: raw.nameKo ?? raw.name ?? '',
    orgUnitName: raw.orgUnitName ?? '',
    positionName: raw.positionName ?? '',
    jobTitle: raw.jobTitleName ?? raw.jobTitle ?? '',

    // 근무 지표 (숫자: 0으로 기본값 - 통계 필드)
    workDays: raw.workingDays ?? raw.workDays ?? 0,
    scheduledHours: raw.regularHours ?? raw.scheduledHours ?? 0,
    actualHours: raw.actualHours ?? 0,
    lateCount: raw.lateCount ?? 0,
    overtimeHours: raw.overtimeHours ?? 0,

    // 대휴 (V60.x: days 단위로 통일, legacy hours 필드 하위호환)
    compOffAccrued: raw.compOffAccruedDays ?? raw.compOffAccruedHours ?? raw.compOffAccrued ?? 0,
    compOffUsed: raw.compOffUsedDays ?? raw.compOffUsedHours ?? raw.compOffUsed ?? 0,

    // 출결/휴가
    absenceCount: raw.absenceCount ?? 0,
    annualUsed: raw.annualLeaveUsedDays ?? raw.annualUsed ?? 0,
    publicDutyUsed: raw.publicDutyUsedDays ?? raw.publicDutyUsed ?? 0,
  };
}
